<template>
  <div>
    <v-toolbar
      dense
      tabs
      color="primary darken-2"
      dark
      class="page_title"
    >
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <a href="javascript: history.go(-1)" class="pa-0">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
         Investment Details
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
              <router-link :to="'/savings'" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tabs
        v-model="tabs"
        color="transparent"
        slider-color="white"
        slot="extension"
        grow
      >
        <v-tab
          v-for="tabsItem in tabsItems"
          :key="tabsItem.id"
          :to="tabsItem.link"
        >
          {{ tabsItem.title }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <div class="investment-detail-container">
            <!-- Main Statistics -->
      <v-layout row class="mb-4">

        <v-flex md3 class="px-1">
          <v-card class="stat-card teal lighten-5" elevation="2">
            <v-card-text class="text-center pa-3">
              <v-icon size="28" color="teal darken-2">fas fa-coins</v-icon>
              <div class="caption mt-1">Total Paid</div>
              <div class="subtitle-1 font-weight-bold teal--text">
                {{ investment.total_paid | formatAmount }} FCFA
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md3 class="px-1">
          <v-card class="stat-card green lighten-5" elevation="2">
            <v-card-text class="text-center pa-3">
              <v-icon size="28" color="green darken-2">fas fa-percentage</v-icon>
              <div class="caption mt-1">Interest</div>
              <div class="subtitle-1 font-weight-bold green--text">
                {{ investment.interest_earned | formatAmount }} FCFA
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md3 class="px-1">
          <v-card class="stat-card orange lighten-5" elevation="2">
            <v-card-text class="text-center pa-3">
              <v-icon size="28" color="orange darken-2">fas fa-exclamation-triangle</v-icon>
              <div class="caption mt-1">Penalties</div>
              <div class="subtitle-1 font-weight-bold orange--text">
                {{ investment.total_penalties | formatAmount }} FCFA
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md3 class="px-1">
          <v-card class="stat-card purple lighten-5" elevation="2">
            <v-card-text class="text-center pa-3">
              <v-icon size="28" color="purple darken-2">fas fa-calendar-check</v-icon>
              <div class="caption mt-1">Progress</div>
              <div class="subtitle-1 font-weight-bold purple--text">
                {{ progressPercentage }}%
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>

        <!-- Header -->
        <v-card class="elevation-8 mb-4" style="border-radius: 16px; overflow: hidden;">
            <div :class="['investment-header', statusClass]">
                <v-layout row wrap align-center class="pa-4">
                    <v-flex xs12 md6>
                        <h2 class="white--text display-1 font-weight-bold">
                            <v-icon large color="white" class="mr-2">fas fa-chart-line</v-icon>
                            Investment #{{ investment.id }}
                        </h2>
                        <p class="white--text subtitle-1 mb-0">{{ investment.investment_amount | formatAmount }} FCFA</p>
                    </v-flex>
                    <v-flex xs12 md3 class="text-md-center mt-3 mt-md-0">
                        <v-chip :color="statusColor" dark large>
                            <v-icon left>{{ statusIcon }}</v-icon>
                            {{ statusText }}
                        </v-chip>
                    </v-flex>
                    <v-flex xs12 md3 class="text-md-right mt-3 mt-md-0">
                        <!-- 🔥 COUNTDOWN TIMER -->
                        <div class="countdown-box">
                            <v-icon color="white" class="mr-1">fas fa-calendar-alt</v-icon>
                            <div>
                                <p class="caption white--text mb-0 opacity-8">Ends in</p>
                                <p class="title white--text font-weight-bold mb-0">{{ daysRemaining }} days</p>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </v-card>

        <!-- 🔥 NEXT PAYMENT ACTION (MISE EN AVANT) -->
        <v-card v-if="nextPaymentAction" class="elevation-12 mb-4 payment-action-card" style="border-radius: 16px;">
            <v-card-text class="pa-5">
                <v-layout row wrap align-center>
                    <v-flex xs12 md7>
                        <h2 class="headline font-weight-bold mb-2">
                            <v-icon large :color="nextPaymentAction.color">{{ nextPaymentAction.icon }}</v-icon>
                            {{ nextPaymentAction.title }}
                        </h2>
                        <p class="body-1 mb-2">{{ nextPaymentAction.description }}</p>

                        <!-- Détails du paiement suivant -->
                        <v-layout row wrap class="mt-3">
                            <v-flex xs6 sm4 class="pr-2">
                                <div class="payment-detail">
                                    <span class="caption grey--text">Amount</span>
                                    <p class="title font-weight-bold mb-0">{{ nextPaymentAction.amount | formatAmount }} FCFA</p>
                                </div>
                            </v-flex>
                            <v-flex xs6 sm4 class="pr-2" v-if="nextPaymentAction.dueDate">
                                <div class="payment-detail">
                                    <span class="caption grey--text">Due Date</span>
                                    <p class="title font-weight-bold mb-0">{{ nextPaymentAction.dueDate | formatDate }}</p>
                                </div>
                            </v-flex>
                            <v-flex xs6 sm4 v-if="nextPaymentAction.penalty > 0">
                                <div class="payment-detail">
                                    <span class="caption red--text">Penalty</span>
                                    <p class="title font-weight-bold red--text mb-0">{{ nextPaymentAction.penalty | formatAmount }} FCFA</p>
                                </div>
                            </v-flex>
                        </v-layout>

                        <!-- Countdown / Warning -->
                        <v-alert v-if="nextPaymentAction.warning" :type="nextPaymentAction.warningType" :value="true" class="mt-3 mb-0">
                            <v-icon left>{{ nextPaymentAction.warningIcon }}</v-icon>
                            {{ nextPaymentAction.warning }}
                        </v-alert>

                        <!-- 💡 Subtle Partial Payment Reminder (only for months 2-10) -->
                        <v-chip
                            v-if="nextPaymentAction.paymentId && nextPaymentAction.canBePartial"
                            small
                            color="blue lighten-4"
                            text-color="blue darken-2"
                            class="mt-2"
                        >
                            <v-icon x-small left>fas fa-info-circle</v-icon>
                            Partial payments accepted
                        </v-chip>
                    </v-flex>

                    <v-flex xs12 md5 class="text-xs-center text-md-right mt-3 mt-md-0">
                        <v-btn
                            x-large
                            :color="nextPaymentAction.buttonColor"
                            class="white--text elevation-8"
                            @click="makePayment(nextPaymentAction.paymentId)"
                            style="padding: 0 40px; font-size: 18px;"
                        >
                            <v-icon left large>{{ nextPaymentAction.buttonIcon }}</v-icon>
                            {{ nextPaymentAction.buttonText }}
                        </v-btn>

                        <!-- Info supplémentaire -->
                        <p class="caption grey--text mt-2 mb-0" v-if="nextPaymentAction.info">
                            {{ nextPaymentAction.info }}
                        </p>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>





        <!-- 🔥 RECENT PAYMENTS HIGHLIGHT (Top 3) -->
        <v-card v-if="recentPayments.length > 0" class="elevation-4 mb-4" style="border-radius: 12px;">
            <v-card-title class="green darken-2 white--text">
                <v-icon color="white" class="mr-2">fas fa-receipt</v-icon>
                Recent Payments
                <v-spacer></v-spacer>
                <v-chip small color="white" text-color="green darken-2">
                    {{ recentPayments.length }} payment{{ recentPayments.length > 1 ? 's' : '' }}
                </v-chip>
            </v-card-title>
            <v-list two-line>
                <template v-for="(transaction, index) in recentPayments">
                    <v-list-tile :key="transaction.id">
                        <v-list-tile-avatar>
                            <v-icon :color="getTransactionColor(transaction.transaction_type)" large>
                                {{ getTransactionIcon(transaction.transaction_type) }}
                            </v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">
                                {{ transaction.description }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                                {{ transaction.transaction_date | formatDateTime }}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-chip small :color="getTransactionColor(transaction.transaction_type)" dark>
                                {{ getTransactionSign(transaction.transaction_type) }}{{ transaction.amount | formatAmount }} FCFA
                            </v-chip>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index < recentPayments.length - 1" :key="'div-' + index"></v-divider>
                </template>
            </v-list>
            <v-card-actions v-if="transactions.length > 3">
                <v-spacer></v-spacer>
                <v-btn flat color="teal darken-2" @click="showAllTransactions = true">
                    View All ({{ transactions.length }})
                    <v-icon right small>fas fa-arrow-down</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card class="elevation-4 mb-4 text-center pa-4" style="border-radius: 12px;">
          <v-icon size="48" color="blue darken-2">fas fa-history</v-icon>
          <h3 class="blue--text darken-2 mt-2 mb-3">
            View Complete Payment History
          </h3>
          <p class="grey--text body-2 mb-3">
            See all your payment transactions including validated, pending, and cancelled payments
          </p>
          <v-btn
            large
            color="blue darken-2"
            class="white--text"
            :to="`/savings/investments/${investment.id}/payments-history`"
          >
            <v-icon left>fas fa-list-alt</v-icon>
            View Payment History
          </v-btn>
        </v-card>
        </v-card>

        <!-- Payment Schedule (monthly) - SIMPLIFIÉ -->
        <v-card v-if="investment.payment_type === 'monthly'" class="elevation-4 mb-4" style="border-radius: 12px;">
            <v-card-title class="purple darken-2 white--text">
                <v-icon color="white" class="mr-2">fas fa-calendar-alt</v-icon>
                Payment Schedule (10 Months)
            </v-card-title>
            <v-card-text class="pa-0">
                <v-list two-line>
                    <template v-for="(payment, index) in payments">
                        <v-list-tile :key="payment.id" :class="getPaymentTileClass(payment)">
                            <v-list-tile-avatar>
                                <v-chip small :color="getMonthColor(payment.month_number)" dark>
                                    M{{ payment.month_number }}
                                </v-chip>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <strong>Month {{ payment.month_number }}</strong>
                                    <v-chip small :color="getStatusColor(payment.status)" dark class="ml-2">
                                        <v-icon x-small left>{{ getStatusIcon(payment.status) }}</v-icon>
                                        {{ getStatusLabel(payment.status) }}
                                    </v-chip>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Due: {{ payment.due_date | formatDate }}
                                    <span v-if="payment.penalty_applied > 0" class="red--text ml-2">
                                        • Penalty: {{ payment.penalty_applied | formatAmount }} FCFA
                                    </span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <div class="text-xs-right">
                                    <div class="caption grey--text">Amount</div>
                                    <div class="body-2 font-weight-bold">
                                        {{ payment.amount_due | formatAmount }} FCFA
                                    </div>
                                    <div v-if="payment.amount_paid > 0" class="caption green--text">
                                        Paid: {{ payment.amount_paid | formatAmount }}
                                    </div>
                                    <div v-if="payment.remaining_amount > 0" class="caption orange--text">
                                        Remaining: {{ payment.remaining_amount | formatAmount }}
                                    </div>
                                </div>
                            </v-list-tile-action>

                            <v-list-tile-action v-if="payment.status === 'completed'">
                                <v-icon color="green" large>fas fa-check-circle</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-action v-else-if="canPayThisMonth(payment)">
                                <v-btn
                                    :color="payment.status === 'partial' ? 'orange darken-2' : 'teal darken-2'"
                                    class="white--text"
                                    @click="makePayment(payment.id)"
                                >
                                    <v-icon small left>fas fa-credit-card</v-icon>
                                    {{ payment.status === 'partial' ? 'Continue' : 'Pay Now' }}
                                </v-btn>
                            </v-list-tile-action>

                            <v-list-tile-action v-else>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon color="grey" v-on="on">fas fa-lock</v-icon>
                                    </template>
                                    <span>Complete previous payments first</span>
                                </v-tooltip>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider v-if="index < payments.length - 1" :key="'divider-' + index"></v-divider>
                    </template>
                </v-list>
            </v-card-text>
        </v-card>

        <!-- Full Transaction History (expandable) -->
        <v-card v-if="showAllTransactions || recentPayments.length === 0" class="elevation-4" style="border-radius: 12px;">
            <v-card-title class="blue darken-2 white--text">
                <v-icon color="white" class="mr-2">fas fa-history</v-icon>
                Transaction History
                <v-spacer></v-spacer>
                <v-btn v-if="showAllTransactions && recentPayments.length > 0" icon dark @click="showAllTransactions = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-data-table
                    :headers="transactionHeaders"
                    :items="transactions"
                    :hide-actions="transactions.length <= 10"
                    :no-data-text="'No transactions yet'"
                    :items-per-page="10"
                    class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td class="text-xs-center" style="width: 70px;">
                            <v-icon :color="getTransactionColor(props.item.transaction_type)" large>
                                {{ getTransactionIcon(props.item.transaction_type) }}
                            </v-icon>
                        </td>
                        <td class="text-xs-left">
                            <div class="font-weight-bold body-1">{{ props.item.description }}</div>
                            <div class="caption grey--text">
                                {{ props.item.transaction_date | formatDateTime }}
                            </div>
                        </td>
                        <td class="text-xs-center">
                            <v-chip small :color="getTransactionColor(props.item.transaction_type)" dark>
                                <v-icon x-small left>{{ getTransactionIcon(props.item.transaction_type) }}</v-icon>
                                {{ props.item.transaction_type | formatTransactionType }}
                            </v-chip>
                        </td>
                        <td class="text-xs-right">
                            <div class="font-weight-bold body-1"
                                 :class="getTransactionColor(props.item.transaction_type) + '--text'">
                                {{ getTransactionSign(props.item.transaction_type) }}
                                {{ props.item.amount | formatAmount }} FCFA
                            </div>
                        </td>
                    </template>

                    <template v-slot:no-data>
                        <div class="pa-4 text-xs-center">
                            <v-icon size="64" color="grey lighten-1">fas fa-inbox</v-icon>
                            <p class="grey--text mt-3 title">No transactions yet</p>
                            <p class="grey--text caption">Transactions will appear here when payments are made</p>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
                <!-- Progress Bar -->
        <v-card class="elevation-4 mb-4 pa-4" style="border-radius: 12px;">
            <h3 class="teal--text text--darken-2 mb-3">
                <v-icon color="teal darken-2">fas fa-tasks</v-icon>
                Overall Progress
            </h3>
            <v-progress-linear
                :value="progressPercentage"
                height="25"
                color="teal darken-2"
                striped
            >
                <strong class="white--text">{{ progressPercentage }}%</strong>
            </v-progress-linear>
        </v-card>
    </div>
          </div></div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            investment: {},
            payments: [],
            transactions: [],
            showAllTransactions: false,
        }
    },

    computed: {
        statusClass() {
            const classes = {
                'active': 'status-active',
                'completed': 'status-completed',
                'cancelled': 'status-cancelled',
                'pending_first_payment': 'status-pending'
            }
            return classes[this.investment.status] || 'status-default'
        },

        transactionHeaders() {
            return [
                { text: '', align: 'center', sortable: false, value: 'icon', width: '70px' },
                { text: 'Description', align: 'left', sortable: true, value: 'description' },
                { text: 'Type', align: 'center', sortable: true, value: 'transaction_type' },
                { text: 'Amount', align: 'right', sortable: true, value: 'amount' }
            ]
        },

        statusColor() {
            const colors = {
                'active': 'green',
                'completed': 'blue',
                'cancelled': 'red',
                'pending_first_payment': 'orange'
            }
            return colors[this.investment.status] || 'grey'
        },

        statusIcon() {
            const icons = {
                'active': 'fas fa-check-circle',
                'completed': 'fas fa-trophy',
                'cancelled': 'fas fa-times-circle',
                'pending_first_payment': 'fas fa-clock'
            }
            return icons[this.investment.status] || 'fas fa-question-circle'
        },

        statusText() {
            const texts = {
                'active': 'Active',
                'completed': 'Completed',
                'cancelled': 'Cancelled',
                'pending_first_payment': 'Pending First Payment'
            }
            return texts[this.investment.status] || 'Unknown'
        },

        progressPercentage() {
            if (this.investment.payment_type === 'one_time') {
                return this.investment.one_time_payment_made ? 100 : 0
            } else {
                const completed = this.payments.filter(p => p.status === 'completed').length
                return Math.round((completed / 10) * 100)
            }
        },

        daysRemaining() {
            if (!this.investment.end_date) return 0
            const today = new Date()
            const endDate = new Date(this.investment.end_date)
            const diffTime = endDate - today
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            return Math.max(0, diffDays)
        },

        // 🔥 Top 3 recent payments
        recentPayments() {
            return this.transactions
                .filter(t =>
                    t.transaction_type === 'payment' &&
                    t.amount > 0 &&
                    t.validation_status === 'Validated'  // ✅ Seulement validées
                )
                .slice(0, 3)
        },
        pendingValidationPayments() {
            return this.transactions
                .filter(t =>
                    t.transaction_type === 'payment' &&
                    t.transaction_type === 'payment' &&
                    t.amount > 0 &&
                    t.validation_status === 'Pending'
                )
        },
       // ✅ Mettre à jour UNIQUEMENT la computed property nextPaymentAction

nextPaymentAction() {
    if (!this.investment.id) return null

    // ==================== ONE-TIME PAYMENT ====================
    if (this.investment.payment_type === 'one_time') {
        // ✅ Vérifier si paiement validé
        const hasValidatedPayment = this.transactions.some(
            t => t.transaction_type === 'payment' &&
                 t.validation_status === 'Validated' &&
                 t.amount > 0
        )

        if (hasValidatedPayment) {
            // ✅ Paiement validé, investissement actif
            return null
        }

        // ✅ Vérifier si paiement en attente
        const pendingPayments = this.transactions.filter(
            t => t.transaction_type === 'payment' &&
                 t.validation_status === 'Pending' &&
                 t.amount > 0
        )

        const hasPendingPayment = pendingPayments.length > 0

        if (hasPendingPayment) {
            // ✅ Afficher info + permettre de payer à nouveau
            return {
                title: '⏳ Payment Awaiting Validation',
                description: `You have ${pendingPayments.length} payment(s) waiting for manager validation. You can submit another payment if needed.`,
                amount: this.investment.investment_amount,
                dueDate: null,
                penalty: 0,
                warning: '📋 A manager will review your payment(s) soon. If you made an error, you can submit a new payment.',
                warningType: 'info',
                warningIcon: 'fas fa-info-circle',
                buttonText: 'Pay Again?',
                buttonColor: 'orange darken-2',
                buttonIcon: 'fas fa-credit-card',
                color: 'blue darken-2',
                icon: 'fas fa-clock',
                info: `${pendingPayments.length} payment(s) pending validation`,
                paymentId: null,  // ✅ null = one-time payment route
                canBePartial: false,
                disabled: false  // ✅ Permettre de payer à nouveau
            }
        }

        // ✅ Aucun paiement ou tous annulés - Afficher le délai de 2 jours
        const creationDate = new Date(this.investment.creation_date)
        const deadline = new Date(creationDate.getTime() + 2 * 24 * 60 * 60 * 1000)
        const now = new Date()
        const hoursLeft = Math.max(0, Math.floor((deadline - now) / (1000 * 60 * 60)))

        return {
            title: 'One-Time Payment Required',
            description: 'Pay the full investment amount to activate your investment.',
            amount: this.investment.investment_amount,
            dueDate: null,
            penalty: 0,
            warning: hoursLeft > 0
                ? `⏰ ${hoursLeft} hours remaining before cancellation!`
                : '⚠️ Payment deadline passed - Investment may be cancelled',
            warningType: hoursLeft > 0 ? 'warning' : 'error',
            warningIcon: 'fas fa-clock',
            buttonText: 'Pay Now',
            buttonColor: 'teal darken-2',
            buttonIcon: 'fas fa-credit-card',
            color: 'teal darken-2',
            icon: 'fas fa-money-bill-wave',
            info: 'Must be paid within 2 days of investment creation',
            paymentId: null,
            canBePartial: false,
            disabled: false
        }
    }

    // ==================== MONTHLY PAYMENT ====================
    if (this.investment.payment_type === 'monthly' && this.payments.length > 0) {
        const nextPayment = this.payments.find(p => p.status !== 'completed')

        if (nextPayment) {
            const today = new Date()
            const dueDate = new Date(nextPayment.due_date)
            const gracePeriod = new Date(nextPayment.grace_period_end)
            const isLate = today > gracePeriod
            const daysUntilDue = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24))

            // ✅ Vérifier si des paiements sont en attente de validation
            const hasPending = nextPayment.pending_transactions > 0

            if (hasPending && nextPayment.status !== 'completed') {
                return {
                    title: `⏳ Month ${nextPayment.month_number} - Awaiting Validation`,
                    description: `You have ${nextPayment.pending_transactions} payment(s) waiting for manager validation.`,
                    amount: nextPayment.remaining_amount,
                    dueDate: nextPayment.due_date,
                    penalty: nextPayment.penalty_applied,
                    warning: nextPayment.validated_transactions > 0
                        ? `✅ ${nextPayment.validated_transactions} payment(s) already validated. ${nextPayment.pending_transactions} pending.`
                        : `📋 ${nextPayment.pending_transactions} payment(s) submitted, waiting for validation.`,
                    warningType: 'info',
                    warningIcon: 'fas fa-info-circle',
                    buttonText: nextPayment.remaining_amount > 0 ? 'Pay Again?' : 'Waiting...',
                    buttonColor: nextPayment.remaining_amount > 0 ? 'orange darken-2' : 'grey',
                    buttonIcon: nextPayment.remaining_amount > 0 ? 'fas fa-plus' : 'fas fa-clock',
                    color: 'blue darken-2',
                    icon: 'fas fa-clock',
                    info: 'Payments will be validated by a manager',
                    paymentId: nextPayment.remaining_amount > 0 ? nextPayment.id : null,
                    canBePartial: nextPayment.month_number > 1,
                    disabled: nextPayment.remaining_amount === 0
                }
            }

            // Pas de paiement en attente, afficher action normale
            let warning = null
            let warningType = 'info'
            let warningIcon = 'fas fa-info-circle'

            if (nextPayment.month_number === 1 && this.investment.status === 'pending_first_payment') {
                const creationDate = new Date(this.investment.creation_date)
                const deadline = new Date(creationDate.getTime() + 2 * 24 * 60 * 60 * 1000)
                const hoursLeft = Math.max(0, Math.floor((deadline - today) / (1000 * 60 * 60)))
                warning = `⚠️ First payment MUST be complete within ${hoursLeft} hours or investment will be cancelled!`
                warningType = 'error'
                warningIcon = 'fas fa-exclamation-triangle'
            } else if (isLate) {
                warning = `⚠️ Payment is LATE! Penalty of ${this.$options.filters.formatAmount(nextPayment.penalty_applied)} FCFA applied.`
                warningType = 'error'
                warningIcon = 'fas fa-exclamation-triangle'
            } else if (daysUntilDue <= 3) {
                warning = `⏰ Payment due in ${daysUntilDue} day(s). Grace period ends on ${this.$options.filters.formatDate(nextPayment.grace_period_end)}.`
                warningType = 'warning'
                warningIcon = 'fas fa-clock'
            }

            return {
                title: nextPayment.status === 'partial'
                    ? `Continue Payment - Month ${nextPayment.month_number}`
                    : `Next Payment - Month ${nextPayment.month_number}`,
                description: nextPayment.status === 'partial'
                    ? `You've paid ${this.$options.filters.formatAmount(nextPayment.amount_paid)} FCFA (validated). Complete the remaining amount.`
                    : `Your ${this.getOrdinal(nextPayment.month_number)} monthly installment is ${isLate ? 'overdue' : 'due'}.`,
                amount: nextPayment.remaining_amount || nextPayment.amount_due + nextPayment.penalty_applied,
                dueDate: nextPayment.due_date,
                penalty: nextPayment.penalty_applied,
                warning,
                warningType,
                warningIcon,
                buttonText: nextPayment.status === 'partial' ? 'Continue Payment' : 'Pay Now',
                buttonColor: nextPayment.status === 'partial' ? 'orange darken-2' : 'teal darken-2',
                buttonIcon: 'fas fa-credit-card',
                color: isLate ? 'red darken-2' : (nextPayment.status === 'partial' ? 'orange darken-2' : 'teal darken-2'),
                icon: isLate ? 'fas fa-exclamation-triangle' : (nextPayment.status === 'partial' ? 'fas fa-clock' : 'fas fa-calendar-check'),
                info: nextPayment.month_number > 1 ? 'Partial payments accepted' : 'First payment must be complete',
                paymentId: nextPayment.id,
                canBePartial: nextPayment.month_number > 1,
                disabled: false
            }
        }
    }

    return null
}
    },

    filters: {
        formatAmount(value) {
            return new Intl.NumberFormat('fr-FR').format(value)
        },

        formatDate(value) {
            if (!value) return '-'
            return new Date(value).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })
        },

        formatDateTime(value) {
            if (!value) return '-'
            return new Date(value).toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        formatTransactionType(value) {
            const types = {
                'payment': 'Payment',
                'penalty': 'Penalty',
                'interest': 'Interest',
                'transfer': 'Transfer'
            }
            return types[value] || value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    methods: {
        async loadInvestmentData() {
            this.$store.commit('setIsLoading', true)
            const investmentId = this.$route.params.investment_id

            try {
                const response = await axios.get(`/api/v1/savings/investments/${investmentId}/`)
                this.investment = response.data.investment
                this.payments = response.data.payments || []
                this.transactions = response.data.transactions || []
            } catch (error) {
                this.$store.commit('setSnackBarMessage', 'Error loading investment')
                this.$store.commit('setSnackBarColor', 'red darken-4')
                this.$store.commit('activateSnackBar', true)

                setTimeout(() => {
                    this.$router.push('/savings/investments')
                }, 2000)
            } finally {
                this.$store.commit('setIsLoading', false)
            }
        },

        canPayThisMonth(payment) {
            if (payment.month_number === 1) return true
            const previousMonth = this.payments.find(p => p.month_number === payment.month_number - 1)
            return previousMonth && previousMonth.status === 'completed'
        },

      makePayment(paymentId) {
          // ✅ Vérifier si l'action est désactivée
          if (this.nextPaymentAction && this.nextPaymentAction.disabled) {
              this.$store.commit('setSnackBarMessage', 'Please wait for payment validation')
              this.$store.commit('setSnackBarColor', 'orange darken-2')
              this.$store.commit('activateSnackBar', true)
              return
          }

          // ✅ Construire la route selon le type de paiement
          let route

          if (paymentId) {
              // Monthly payment - avec payment_id
              route = `/savings/investments/pay/${this.investment.id}/${paymentId}`
          } else {
              // One-time payment - sans payment_id
              route = `/savings/investments/pay/${this.investment.id}`
          }

          this.$router.push(route)
      },
        getPaymentTileClass(payment) {
            if (payment.status === 'completed') return 'completed-tile'
            if (!this.canPayThisMonth(payment)) return 'locked-tile'
            if (payment.status === 'partial') return 'partial-tile'
            return ''
        },

        getMonthColor(month) {
            const colors = ['teal', 'blue', 'green', 'purple', 'orange', 'pink', 'indigo', 'cyan', 'lime', 'amber']
            return colors[(month - 1) % colors.length]
        },

          getStatusColor(status) {
          const colors = {
          'completed': 'green',
          'partial': 'orange',
          'pending': 'grey',
          'failed': 'red'
          }
          return colors[status] || 'grey'
          },
    getStatusIcon(status) {
        const icons = {
            'completed': 'fas fa-check',
            'partial': 'fas fa-clock',
            'pending': 'fas fa-hourglass-half',
            'failed': 'fas fa-times'
        }
        return icons[status] || 'fas fa-question'
    },

    getStatusLabel(status) {
        const labels = {
            'completed': 'Paid',
            'partial': 'Partial',
            'pending': 'Pending',
            'failed': 'Failed'
        }
        return labels[status] || status
    },

    getTransactionColor(type) {
        const colors = {
            'payment': 'green',
            'penalty': 'red',
            'interest': 'teal',
            'transfer': 'blue'
        }
        return colors[type] || 'grey'
    },

    getTransactionIcon(type) {
        const icons = {
            'payment': 'fas fa-arrow-down',
            'penalty': 'fas fa-exclamation-triangle',
            'interest': 'fas fa-percentage',
            'transfer': 'fas fa-exchange-alt'
        }
        return icons[type] || 'fas fa-question'
    },

    getTransactionSign(type) {
        return type === 'penalty' ? '-' : '+'
    },

    getOrdinal(n) {
        const s = ['th', 'st', 'nd', 'rd']
        const v = n % 100
        return n + (s[(v - 20) % 10] || s[v] || s[0])
    }
},

mounted() {
    this.loadInvestmentData()
    document.title = "PettyCash | Investment Details"
    this.$store.commit('setCloseURL', "/savings/investments")
}
}
</script>
<style scoped>
.investment-detail-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
}

.investment-header {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.status-active {
    background: linear-gradient(135deg, #00897b 0%, #004d40 100%);
}

.status-completed {
    background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
}

.status-cancelled {
    background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
}

.status-pending {
    background: linear-gradient(135deg, #f57c00 0%, #e65100 100%);
}

.countdown-box {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.2);
    padding: 12px 20px;
    border-radius: 8px;
    backdrop-filter: blur(10px);
}

.opacity-8 {
    opacity: 0.8;
}

.stat-card {
    border-radius: 12px !important;
    transition: transform 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.payment-action-card {
    background: linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%);
    border: 3px solid #00897b;
    animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
    0%, 100% {
        border-color: #00897b;
        box-shadow: 0 0 0 0 rgba(0, 137, 123, 0.4);
    }
    50% {
        border-color: #004d40;
        box-shadow: 0 0 0 10px rgba(0, 137, 123, 0);
    }
}

.payment-detail {
    background: white;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 8px;
}

.completed-tile {
    background: #e8f5e9 !important;
}

.partial-tile {
    background: #fff3e0 !important;
}

.locked-tile {
    background: #f5f5f5 !important;
    opacity: 0.6;
}
</style>